let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2KXQ0")).then(() => parcelRequire('4ERgw'));